import { getTouristList,actTourist,delTourist } from '@/api';
//状态，不允许直接对state操作，只能通过mutations或者actions改变
const state = {
    customer:[]
}


//同步方法
const mutations = {
    setCustomer (state) {
        getTouristList().then(res => {
            console.log(res)
            if(res.code == 0){
                state.customer = res.data
            }
        }).catch(err => {
            console.log(err)
        }) 
    },
}

//异步方法
const actions = {
    setCustomerAction( {commit} ){
        commit('setCustomer')
    },
    addCustomerAction( {commit},obj ){
        return new Promise((resole,reject) => {
            actTourist(obj).then(res => {
                console.log(res)
                if(res.code == 0){
                    resole(res)                    
                }
            }).catch(err => {
                reject(err)
            })
        })
    },
    delCustomerAction( {commit},id ){
        return new Promise((resole,reject) => {
            delTourist({followId:id}).then(res => {
                console.log(res)
                if(res.code == 0){
                    resole(res)                    
                }
            }).catch(err => {
                reject(err)
            })
        })
    }
    
}
export default{
    namespaced: true,
    state,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/customer.js